/* eslint-disable import/no-cycle */
/* eslint-disable no-param-reassign */
export const pushTo = (component, title, url) => ({
	type: 'pushForm',
	payload: {
		form: component,
		title: title,
		url: url
	},
});

export const overallPayment = (priceRial, canBePayed, packsCount, cartIds) => ({
	type: 'overallPayment',
	priceRial: priceRial,
	canBePayed: canBePayed,
	packsCount: packsCount,
	cartIds: cartIds,
});

export const setTitleParent = (title) => ({
	type: 'setTitle',
	payload: {
		title: title,
	},
});

export const updateTab = (index) => ({
	type: 'updateIndexTab',
	payload: {
		index: index
	},
});

export const getStack = ({
		type: 'getStack',
});

export const popStack = () => {
	return {
		type: 'popStack'
	};
};

export const popToRoot = () => {
	return {
		type: 'popToRoot'
	};
};

export const popToForm = (index) => {
	return {
		type: 'popToForm',
		payload: {
			index: index
		},
	};
};

export const clearStack = () => {
	return {
		type: 'clearStack'
	};
};


export const pop = () => {
  return {
    type: 'pop'
  };
};
